import { render, staticRenderFns } from "./IconSoundcloud.vue?vue&type=template&id=ba1f0bb6&"
import script from "./IconSoundcloud.vue?vue&type=script&lang=js&"
export * from "./IconSoundcloud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports